import {Inject, ModelEvents} from '@denishussar/html5-game-engine';
import {CrazyGamesAdsType} from '../../Common/CrazyGamesAds/CrazyGamesAds';
import {GameEvent, GameEventAdAbort, GameEventAdComplete, GameEventAdStart} from '../../Constants/GameEvent';
import {GameModel} from '../../Models/GameModel';
import {GameLogic} from '../GameLogic';
import {ADS_TYPE, AzerionAdsAssoc} from "../../Common/Ads/AdsType";
import {BaseAdsLogic, REWARDED_ADS_TYPE} from "../Ads/BaseAdsLogic";
import {AdsBannerLogic} from "../../Common/Ads/AdsBannerLogic";

export class AzerionAdsLogic extends BaseAdsLogic {
    private _sdk: any = null;
    private _adsBannerLogic: AdsBannerLogic

    constructor(
        private _modelEvents: ModelEvents,
        private _model: GameModel,
        private _gameLogic: GameLogic,
    ) {
        super();

        this._adsBannerLogic = new AdsBannerLogic();

        window["GD_OPTIONS"] = {
            "gameId": "c3a89accf6044bd298ca2fe99b7d8509",
            "onEvent": function(event) {
                switch (event.name) {
                    case "SDK_READY":
                        this.isSDKReady = true;
                        break;
                    case "SDK_GAME_START":
                        // advertisement done, resume game logic and unmute audio
                        break;
                    case "SDK_GAME_PAUSE":
                        // pause game logic / mute audio
                        break;
                    case "SDK_GDPR_TRACKING":
                        // this event is triggered when your user doesn't want to be tracked
                        break;
                    case "SDK_GDPR_TARGETING":
                        window['__DISABLE_ANALYTICS__'] = true;
                        // this event is triggered when your user doesn't want personalised targeting of ads and such
                        break;
                    case "SDK_REWARDED_WATCH_COMPLETE":
                        // this event is triggered when your user completely watched rewarded ad
                        break;
                    case "SDK_ERROR":
                        console.error("AzerionAdsLogic::ERROR", event);
                        break;
                }
            },
        };

        (function(d, s, id, context) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = '//html5.api.gamedistribution.com/libs/gd/api.js';
            (js as HTMLScriptElement).onload = () => {
                if (typeof window['gdsdk']  !== 'undefined' && window['gdsdk'].showAd !== 'undefined') {
                    context._sdk = window['gdsdk'];
                    console.log("AzerionAdsLogic::SDK Loaded")
                } else {
                    console.error("AzerionAdsLogic::Invalid loading SDK")
                }
            }
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'azerion-jssdk', this));
    }

    protected async onRequestAd(type: ADS_TYPE): Promise<void> {
        const azerionAdType = AzerionAdsAssoc[type];
        if (type !== ADS_TYPE.BANNER && !this._sdk.preloadAd(azerionAdType)) {
            console.log('AzerionAdsLogic::', "Can not get ad")
            throw new Error("Can not get ad from AzerionAdsLogic");
        }

        if (type === ADS_TYPE.REWARDED) {
            this._modelEvents.dispatch(this._model, GameEvent.adStart, <GameEventAdStart>{
                id: type,
                time: 0,
            });
        } else if (type === ADS_TYPE.INTERSTITIAL) {
            this._modelEvents.dispatch(this._model, GameEvent.interstitialStart, <GameEventAdStart>{
                id: type,
                time: 0,
            });
        }

        if (type === ADS_TYPE.BANNER) {
            return this.showBanner(azerionAdType);
        }

        return new Promise((resolve, reject) => {
            this._sdk.showAd(azerionAdType)
                .then(() => {

                    if (type === ADS_TYPE.REWARDED) {
                        this.restartRewardedAdTimeout(REWARDED_ADS_TYPE.COMMON);
                        this._modelEvents.dispatch(this._model, GameEvent.adComplete, <GameEventAdComplete>{
                            id: type,
                            time: 0,
                            skip: false,
                            popupName: this._gameLogic.modalsManager.getCurrentKey(),
                        });
                    } else if (type === ADS_TYPE.INTERSTITIAL) {
                        this._modelEvents.dispatch(this._model, GameEvent.interstitialComplete, <GameEventAdComplete>{
                            id: type,
                            time: 0,
                            skip: false,
                            popupName: this._gameLogic.modalsManager.getCurrentKey(),
                        });
                    }

                    resolve();
                })
                .catch((e) => {
                    if (azerionAdType === CrazyGamesAdsType.reward) {
                        this._modelEvents.dispatch(this._model, GameEvent.adAbort, <GameEventAdAbort>{
                            id: azerionAdType,
                            time: 0,
                            skip: false,
                            popupName: this._gameLogic.modalsManager.getCurrentKey(),
                            cause: 'SDK Error',
                            message: e?.error ?? e
                        });
                    } else if (azerionAdType === CrazyGamesAdsType.interstitial) {
                        this._modelEvents.dispatch(this._model, GameEvent.interstitialAbort, <GameEventAdAbort>{
                            id: azerionAdType,
                            time: 0,
                            skip: false,
                            popupName: this._gameLogic.modalsManager.getCurrentKey(),
                            cause: 'SDK Error',
                            message: e?.error ?? e
                        });
                    }

                    console.error('AzerionAdsLogic::',e);

                    reject(e);
                })
        })
    }

    protected showBanner(type: string): void {
        this._sdk.showAd(type, {containerId: "banner-container"})
            .then(() => {
                this._adsBannerLogic.showBanner();
                this._adsBannerLogic.on('adUpdate', () => {
                    this._sdk.showAd(type, {containerId: "banner-container"});
                })
            })
            .catch((e) => {
                console.error('AzerionAdsLogic::', e)
                throw e;
            })
    }

    protected onClearAllBanners(): void {
        this._adsBannerLogic.clearBanner('banner-container');
        this._adsBannerLogic.clearAllBanners();
        // this._sdk.clearBanner('banner-container');
        // this._sdk.clearAllBanners();
    }

    protected onGameplayStart() {
        // this._sdk.gameplayStart();
    }

    protected onGameplayStop() {
        // this._sdk.gameplayStop();
    }
}
